import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import PageContainer from "../../components/PageContainer/PageContainer";
import {
  Grid,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Redireccion } from "../../components/Modals";
// Assets
import { DomicilioIcon } from "assets";
// Services
import ClientService from "services/clientService";
import PublicServices from "services/publicService";
import { URLs } from "../../utils/redirectStep";

function AgenciaDeRetiro() {
  const clientService = new ClientService();
  const publicService = new PublicServices();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    showX: false,
    content: null,
  });

  const [allSucursales, setAllSucursales] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [allLocalidades, setAllLocalidades] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);

  const [departamentoId, setDepartamentoId] = useState("");
  const [localidadId, setLocalidadId] = useState("");
  const [agenciaRetiro, setAgenciaRetiro] = useState({ idAgenciaRetiro: "" });

  const [terminosYCondiciones, setTerminosYCondiciones] = useState(null);
  const [terminos, setTerminos] = useState({ idTermino: null, aceptado: false });

  const [errors, setErrors] = useState({
    idDepartamento: "",
    idBarrio: "",
    idAgenciaRetiro: "",
  });

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  const handleModalCloseClick = () => setModal({ ...modal, open: false });

  const getSucursales = async () => {
    const getAllSucursales = await publicService.getAgenciasRedPagos();
    const formattedSucursales = getAllSucursales.data.map((s) => ({ ...s }));
    setAllSucursales(formattedSucursales);
    return formattedSucursales;
  };

  const buildLocalidades = (sucursalesList) => {
    const list = sucursalesList
      .map((s) => ({
        localidadBarrio: s.localidadBarrio,
        idLocalidad: s.idLocalidad,
        idDepto: s.idDepto,
      }))
      .filter(
        (v, i, self) =>
          i === self.findIndex((t) => t.idLocalidad === v.idLocalidad)
      )
      .sort((a, b) => a.localidadBarrio.localeCompare(b.localidadBarrio));
    setAllLocalidades(list);
  };

  const buildDepartamentos = (sucursalesList) => {
    const list = sucursalesList
      .map((s) => ({ departamento: s.departamento, idDepto: s.idDepto }))
      .filter(
        (v, i, self) => i === self.findIndex((t) => t.idDepto === v.idDepto)
      )
      .sort((a, b) => a.departamento.localeCompare(b.departamento));
    setDepartamentos(list);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getTerminos = await publicService.getTerminosYCondiciones();
        setTerminosYCondiciones(getTerminos);

        const suc = await getSucursales();
        buildLocalidades(suc);
        buildDepartamentos(suc);
      } catch (error) {
        console.error("Error cargando datos:", error);
      }
    };
    fetchData();
  }, []);

  const handleOpenTermsModal = () =>
    setModal({
      open: true,
      showX: true,
      content: (
        <Box
          sx={{
            textAlign: "justify",
            maxHeight: "50vh",
            overflowY: "auto",
            padding: "20px",
            fontSize: "12px",
          }}
        >
          <p style={{ padding: "0rem 0.5rem" }}>
            {terminosYCondiciones?.data?.descripcion}
          </p>
        </Box>
      ),
    });

  const handleTerminosChange = (event) => {
    setTerminos({
      idTermino: terminosYCondiciones?.data?.id,
      aceptado: event.target.checked,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "idDepartamento") {
      const filtered = allLocalidades.filter((x) => x.idDepto === value);
      setLocalidades(filtered);
      setDepartamentoId(value);
      setLocalidadId("");
      setSucursales([]);
      setAgenciaRetiro({ idAgenciaRetiro: "" });
      setErrors((prev) => ({ ...prev, idDepartamento: "" }));
    }

    if (name === "idBarrio") {
      const filtered = allSucursales.filter((x) => x.idLocalidad === value);
      setSucursales(filtered);
      setLocalidadId(value);
      setAgenciaRetiro({ idAgenciaRetiro: "" });
      setErrors((prev) => ({ ...prev, idBarrio: "" }));
    }

    if (name === "idAgenciaRetiro") {
      setAgenciaRetiro({ idAgenciaRetiro: value });
      setErrors((prev) => ({ ...prev, idAgenciaRetiro: "" }));
    }
  };

  const handleValidation = () => {
    let valid = true;
    const newErrors = { idDepartamento: "", idBarrio: "", idAgenciaRetiro: "" };

    if (!departamentoId) {
      newErrors.idDepartamento = "Este campo es obligatorio";
      valid = false;
    }
    if (!localidadId) {
      newErrors.idBarrio = "Este campo es obligatorio";
      valid = false;
    }
    if (!agenciaRetiro.idAgenciaRetiro) {
      newErrors.idAgenciaRetiro = "Este campo es obligatorio";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSolicitarMiTarjeta = async () => {
    if (!handleValidation()) return;

    if (!terminos.aceptado) {
      setModal({
        open: true,
        showX: true,
        message: "Debe aceptar los términos y condiciones para continuar.",
      });
      return;
    }

    setLoading(true);
    try {
      await clientService.termsAndConditions(terminos, location.state.transaction);
    } catch (error) {
      setLoading(false);
      navigate(buildNavigateUrl(URLs.intenteLuego));
      return;
    }

    try {
      const formData = {
        idAgenciaRetiro: agenciaRetiro.idAgenciaRetiro,
        documentacionRequerida: [],
      };
      const response = await clientService.documentsAndBranchAgency(
        formData,
        location.state.transaction
      );
      if (response.code == 200) {
        const newTransaction = { ...location.state.transaction };
        navigate(buildNavigateUrl(URLs.verificacionCelular), {
          state: { transaction: newTransaction },
        });
      } else {
        navigate(buildNavigateUrl(URLs.intenteLuego));
      }
    } catch (error) {
      navigate(buildNavigateUrl(URLs.intenteLuego));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.agenciaDeRetiro}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "start",
          marginTop: "1rem",
          width: mobile ? "90%" : "100%",
        }}
      >
        <img
          src={DomicilioIcon}
          style={{ marginRight: "8px", width: "24px", height: "24px" }}
        />
        <p style={{ fontSize: mobile ? "12px" : "15px", fontWeight: "520" }}>
          ¿DÓNDE QUERÉS RETIRAR TU TARJETA?
        </p>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "start",
          marginTop: mobile ? "0.5rem" : "1rem",
          width: mobile ? "90%" : "100%",
        }}
      >
        <p style={{ fontSize: mobile ? "12px" : "14px" }}>
          Retirá tu tarjeta en la sucursal de RedPagos más cercana a tu
          domicilio.
        </p>
      </Box>

      <Grid container spacing={mobile ? 0 : 3.5}>
        <Grid item xs={12} sm={6} display="flex">
          <FormControl
            fullWidth
            variant="filled"
            error={!!errors.idDepartamento}
            className={classes.formControlCustom}
            sx={{
              margin: "auto",
              marginTop: "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <InputLabel id="departamento-label">Departamento*</InputLabel>
            <Select
              labelId="departamento-label"
              id="idDepartamento"
              name="idDepartamento"
              onChange={handleChange}
              label="Departamento*"
              value={departamentoId}
              className={classes.inputCustom}
              sx={{
                "& .MuiMenuItem-root": { boxShadow: "none" },
                "& .MuiPaper-root": { border: "1px solid #d3d4d5" },
                "&:after": { borderBottom: "2px solid rgb(4 128 143)" },
              }}
            >
              {departamentos.map((depto) => (
                <MenuItem key={depto.idDepto} value={depto.idDepto}>
                  {depto.departamento}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} display="flex">
          <FormControl
            fullWidth
            variant="filled"
            className={classes.formControlCustom}
            error={!!errors.idBarrio}
            sx={{
              margin: "auto",
              marginTop: "1rem",
              width: mobile ? "90%" : "100%",
            }}
          >
            <InputLabel id="barrio-label">Barrio/Localidad*</InputLabel>
            <Select
              labelId="barrio-label"
              id="idBarrio"
              name="idBarrio"
              onChange={handleChange}
              label="Barrio/Localidad*"
              className={classes.inputCustom}
              value={localidadId}
              sx={{
                "& .MuiMenuItem-root": { boxShadow: "none" },
                "& .MuiPaper-root": { border: "1px solid #d3d4d5" },
                "&:after": { borderBottom: "2px solid rgb(4 128 143)" },
              }}
            >
              {departamentoId ? (
                localidades.map((localidad) => (
                  <MenuItem
                    key={localidad.idLocalidad}
                    value={localidad.idLocalidad}
                  >
                    {localidad.localidadBarrio}
                  </MenuItem>
                ))
              ) : (
                <MenuItem key={0} value={0}>
                  Seleccione un departamento
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} display="flex">
          <FormControl
            fullWidth
            variant="filled"
            className={classes.formControlCustom}
            error={!!errors.idAgenciaRetiro}
            sx={{
              margin: "auto",
              marginTop: mobile ? "1rem" : "",
              width: mobile ? "90%" : "100%",
            }}
          >
            <InputLabel id="sucursal-label">Sucursal*</InputLabel>
            <Select
              labelId="sucursal-label"
              id="idAgenciaRetiro"
              name="idAgenciaRetiro"
              className={classes.inputCustom}
              value={agenciaRetiro.idAgenciaRetiro}
              onChange={handleChange}
              label="Sucursal*"
              sx={{
                "& .MuiMenuItem-root": { boxShadow: "none" },
                "& .MuiPaper-root": { border: "1px solid #d3d4d5" },
                "&:after": { borderBottom: "2px solid rgb(4 128 143)" },
              }}
            >
              {sucursales.length > 0 ? (
                sucursales.map((sucursal) => (
                  <MenuItem
                    key={sucursal.idAgenciaRedPagos}
                    value={sucursal.idAgenciaRedPagos}
                  >
                    <p>
                      {sucursal.nombreAgenciaRedPagos}
                      <br />
                      <small>{sucursal.direccionAgenciaRedPagos}</small>
                    </p>
                  </MenuItem>
                ))
              ) : localidadId !== "" ? (
                <MenuItem key={0} value={0}>
                  No hay sucursales
                </MenuItem>
              ) : (
                <MenuItem key={0} value={0}>
                  Seleccione departamento y localidad
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: mobile ? "90%" : "100%",
        }}
      >
        <p
          style={{
            fontSize: "11px",
            lineHeight: "1.2",
            width: "100%",
            textAlign: "left",
            marginTop: "1rem",
          }}
        >
          *Todos los campos son obligatorios.
        </p>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxWidth: "380px",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={terminos.aceptado}
                  onChange={handleTerminosChange}
                  color="primary"
                />
              }
              label={
                <Typography
                  variant="body2"
                  style={{
                    fontSize: mobile ? "10px" : "12px",
                    lineHeight: "1.2",
                    width: "90%",
                    marginBottom: "0.5rem",
                    margin: "auto",
                  }}
                >
                  Al continuar acepta los{" "}
                  <span
                    onClick={handleOpenTermsModal}
                    style={{ cursor: "pointer", fontWeight: "400", color: "#04808f" }}
                  >
                    Términos y condiciones
                  </span>
                </Typography>
              }
            />
            <div className={classes.divBtn}>
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                variant="text"
                disabled={loading}
                onClick={handleSolicitarMiTarjeta}
                sx={{ width: "100%", backgroundColor: "#FFFF" }}
              >
                {"SOLICITAR MI TARJETA"}
              </Button>
            </div>
          </Box>
        </Box>
      </Box>
    </PageContainer>
  );
}

export default AgenciaDeRetiro;
